import { render, staticRenderFns } from "./AttributeField.vue?vue&type=template&id=27512698&"
import script from "./AttributeField.vue?vue&type=script&lang=js&"
export * from "./AttributeField.vue?vue&type=script&lang=js&"
import style0 from "./AttributeField.vue?vue&type=style&index=0&id=27512698&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports